<template>
  <div class="portada-arley" ref="rootRef" aria-label="Portada de XV Años">
    <div class="fondo-gradiente">
      <div class="fondo-arco"></div>
    </div>

    <div class="onda-luz-bg"></div>

    <img src="@/assets/sepp.png" class="adorno velas-superior" alt="" />


    <img src="@/assets/fl.png" class="flor flor-rosa-arriba-der" alt="" />
    
    <img src="@/assets/fl.png" class="flor flor-rosa-abajo-izq" alt="" />
    
    
    <img src="@/assets/fl.png" class="flor flor-blanca-esquina-izq" alt="" />

    <img src="@/assets/sepp.png" class="adorno velas-inferior-der" alt="" />

    <div class="imagen-xv-wrapper shadow-custom">
      <img src="@/assets/M2.webp" class="imagen-xv" alt="Foto protagonista" />
    </div>

    <header class="texto-cabecera">
      <img src="@/assets/se.png" class="separador-floral-top" aria-hidden="true" alt="" />
   <p class="texto-introduccion-xv">
  A very special chapter begins, a moment filled with emotion, dreams, and new beginnings. My fifteenth birthday marks the start of a new stage that I will treasure forever with joy.
<br></p>
    </header>

      
      
  </div>
</template>

<script>
import { onMounted, ref, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)

    onMounted(async () => {
      await nextTick()

      const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

      // Elementos a animar
      const fondo = $('.fondo-gradiente')
      const arco = $('.fondo-arco')
      const foto = $('.imagen-xv-wrapper')
      const textos = $('.texto-cabecera, .controles-inferiores, .parrafo-presentacion-wrapper, .separador-floral-top')
      const adornosSatinados = $('.velas-superior, .velas-inferior-der')
      const flores = $('.flor')
      const brilloUnico = $('.brillo-principal-izq')
      const controles = $('.controles-inferiores')
      const playIcon = $('.play-icon')
      const seekBar = $('.seek-bar')

      // Configuración inicial sin spreads molestos
      const totalElementos = [].concat(fondo, arco, foto, textos, adornosSatinados, flores, brilloUnico, controles, playIcon, seekBar)
      gsap.set(totalElementos, { autoAlpha: 0, y: 30 })
      gsap.set(brilloUnico, { scale: 0 })

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (!e.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1. Fondo y estructura del arco
          tl.to(fondo, { autoAlpha: 1, y: 0, duration: 1 })
            .to(arco, { autoAlpha: 1, y: 0, duration: 0.8 }, '-=0.6')

          // 2. Foto de la quinceañera
          tl.fromTo(
            foto,
            { scale: 0.94, y: 40, filter: 'blur(6px)' },
            { autoAlpha: 1, scale: 1, y: 0, filter: 'blur(0px)', duration: 1.2 },
            '-=0.4'
          )

          // 3. Textos y telas satinadas fijas
          const textosYAdornos = [].concat(textos, adornosSatinados)
          tl.to(
            textosYAdornos,
            {
              autoAlpha: 1,
              y: 0,
              duration: 1,
              stagger: 0.15
            },
            '-=0.8'
          )

          // 4. Las 4 flores exactas
          tl.to(
            flores,
            {
              autoAlpha: 1,
              y: 0,
              rotate: () => gsap.utils.random(-4, 4),
              duration: 1,
              stagger: 0.15
            },
            '-=0.6'
          )

          // 5. Destello de luz a la izquierda del arco
          tl.to(
            brilloUnico,
            {
              autoAlpha: 1,
              scale: 1,
              duration: 0.9,
              onComplete: () => {
                gsap.to(brilloUnico, {
                  opacity: 0.5,
                  scale: 1.15,
                  duration: 1,
                  repeat: -1,
                  yoyo: true,
                  ease: 'sine.inOut'
                })
              }
            },
            '-=0.4'
          )

          // 6. Barra play inferior
          tl.to(controles, { autoAlpha: 1, y: 0, duration: 0.8 }, '-=0.2')
            .to([playIcon, seekBar], { autoAlpha: 1, scale: 1, duration: 0.6, stagger: 0.15 }, '-=0.4')
            .to('.triangle-play', { scale: 1.1, duration: 0.4, repeat: -1, yoyo: true, ease: 'back.out(2)' }, '-=0.2')

          // Animaciones flotantes en las flores
          flores.forEach((flor, i) => {
            gsap.to(flor, {
              y: `+=${gsap.utils.random(4, 10)}`,
              x: `+=${gsap.utils.random(-4, 4)}`,
              rotation: `+=${gsap.utils.random(-0.8, 0.8)}`,
              duration: gsap.utils.random(3.2, 4.6),
              repeat: -1,
              yoyo: true,
              ease: 'sine.inOut',
              delay: i * 0.2
            })
          })

          // Sutil escala de la foto
          gsap.to(foto, {
            scale: 1.01,
            duration: 4.5,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })
          
          // Slider de carga continuo
          gsap.to('.seek-handle', {
            x: '92%',
            duration: 18,
            repeat: -1,
            yoyo: true,
            ease: 'none'
          })

          io.disconnect()
        })
      }, { threshold: 0.45 })

      if (rootRef.value) io.observe(rootRef.value)
    })

    return { rootRef }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,700;1,400&family=Montserrat:wght@400;700&display=swap');

.portada-arley {
  position: relative;
  width: 100%;
  min-height: 100vh;
 background:
  linear-gradient(
    rgb(61, 46, 85) 0%,
    rgba(18, 5, 50, 0.941) 100%
  ),
  url('@/assets/fn.avif') center center / cover no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px 56px;
  box-sizing: border-box;
  overflow: visible;
}

/* GRADIENTE ROSADO DE FONDO */
.fondo-gradiente {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(180deg, #d2b4a3 0%, #c4a18d 60%, #fff 100%);
  z-index: -2;
}

/* ARCO DE FONDO DETRÁS DE LA FOTO */
.fondo-arco {
  position: absolute;
  top: 36vh;
  left: 50%;
  transform: translateX(-50%);
  width: min(92vw, 360px);
  height: 60vh;
  border-radius: 180px 180px 0 0;
  background: #fdf2f3;
  z-index: -1;
}

/* MARCO REDONDEADO LUXURY */
.imagen-xv-wrapper {
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.4);
  margin-top: 38vh;
  margin-bottom: auto;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
  background: #fff;
  will-change: transform, filter, opacity;
}

.imagen-xv {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shadow-custom {
  box-shadow: 
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
}

/* CABECERA EDITORIAL CON EL TEXTO EN INGLÉS */
.texto-cabecera {
  width: min(90vw, 420px);
  text-align: center;
  position: absolute;
  top: 11vh;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
}

.separador-floral-top {
  width: min(50vw, 120px) !important;
  height: auto;
  margin: 0 auto 16px;
  display: block;
  object-fit: contain;
  will-change: transform, opacity;
}

.texto-introduccion-xv {
  font-family: 'Playfair Display', serif;
  font-size: clamp(16px, 2.9vw, 19px);
  color: #ffffff;
  line-height: 1.6;
  margin: 0;
  padding: 0 10px;
  font-weight: 400;
}

/* PARRAFO INFERIOR DE BENDICIÓN y SALMO */
.parrafo-presentacion-wrapper {
  margin-top: 10px;
  width: 100%;
  max-width: 620px;
  text-align: center;
}

.parrafo-presentacion {
  font-family: 'Playfair Display', serif;
  font-size: clamp(14px, 2.6vw, 16px);
  color: #ffffff;
  line-height: 1.7;
  margin-top: 6px;
}

.salmo-ref {
  display: block;
  text-align: right;
  margin-top: 6px;
  font-size: 13px;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
  opacity: 0.8;
}

/* COMPONENTES GRÁFICOS (MÁXIMA ACCURACY CON IMAGE_0DFC83.PNG) */
.flor, .adorno, .brillo {
  position: absolute;
  transform-origin: center;
  will-change: transform, opacity;
  object-fit: contain;
}

.adorno.velas-superior {
  top: -170px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 8 !important;
  width: min(0vw, 0px);
}
.adorno.velas-inferior-der {
  bottom: -190px !important; left: -65px; z-index: 4;
  width: min(630vw, 530px);
  transform: rotate(-2deg);
  opacity: 0 !important;
}

/* POSICIONAMIENTOS PRECISOS DE LAS 4 FLORES */
.flor-rosa-arriba-der {
  top: 30vh; right: -5vw !important; z-index: 1;
  width: min(49vw, 190px) !important ;
}

.flor-rosa-abajo-izq {
  bottom: 12vh; left: -14vw; z-index: 4;
  width: min(46vw, 240px);
}

.flor-blanca-centro-der {
  top: 38vh; right: -3vw; z-index: 3;
  width: min(28vw, 140px);
}

.flor-blanca-esquina-izq {
  bottom: -9vh; left: -8vw; z-index: ;
  width: min(24vw, 20px) !important;
  opacity: 0.45;
}

/* EL ÚNICO DESTELLO BRILLANTE DE LA IZQUIERDA */
.brillo-principal-izq {
  top: 31vh; left: 6vw; z-index: 3;
  width: 140px; opacity: 0.9;
}

/* CONTROLES INFERIORES DEL REPRODUCTOR AUDIO */
.controles-inferiores {
  width: min(92vw, 360px);
  position: relative;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.play-button-bar {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(4px);
  border-radius: 50px;
  padding: 8px;
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
}

.play-icon {
  background: #fff;
  border-radius: 50%;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.triangle-play {
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 16px solid #e1b4b9;
  margin-left: 4px;
  transform-origin: center;
}

.seek-bar {
  flex: 1;
  height: 10px;
  background: #d4cfcc;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
}

.seek-handle {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, #fff, transparent);
  position: absolute;
  top: 0; left: 0;
  border-radius: 5px;
}

.press-play {
  font-family: 'Montserrat', sans-serif;
  font-weight: 700;
  font-size: clamp(14px, 1.8vw, 16px);
  color: #fff;
  margin: 12px 0 0;
  letter-spacing: 0.15em;
  opacity: 0.9;
}

/* RESPONSIVE */
@media (min-width: 992px){
  .portada-arley { padding-top: 24px; }
  .texto-cabecera { top: 12vh; }
}

@media (max-width: 500px) {
  .flor-rosa-arriba-der { right: -18vw; }
  .flor-rosa-abajo-izq { left: -16vw; }
}/* 🌟 DESTELLO BLANCO REFINADO, ENFOCADO Y CHICO PASANDO REPETITIVAMENTE */
/* 🌟 DESTELLO BLANCO CON FORMA ONDULADA REFINADA Y PASO SEMI-HORIZONTAL */
.onda-luz-bg {
  position: absolute;
  top: -60%;
  left: -60%;
  width: 220%;
  height: 220%;
 
}

.onda-luz-premium {
  position: absolute;
  inset: 0;
  /* Reducimos los radios del 25% al 10%-12% y bajamos la opacidad a un destello cristalino (0.15 - 0.25) */
  background: 
    radial-gradient(circle at 30% 50%, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 12%),
    radial-gradient(circle at 50% 52%, rgba(255, 255, 255, 0.35) 0%, rgba(255, 255, 255, 0) 10%),
    radial-gradient(circle at 70% 55%, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0) 12%),
    linear-gradient(
      15deg, 
      rgba(255, 255, 255, 0) 45%,
      rgba(255, 255, 255, 0.08) 48%,
      rgba(255, 255, 255, 0.25) 50%,
      rgba(255, 255, 255, 0.08) 52%,
      rgba(255, 255, 255, 0) 55%
    );
  /* Un blur menor (2px) para que mantenga una forma fina y estilizada, no una nube gigante */
  filter: blur(2px); 
  z-index: 1; 
  animation: barridoOndulado 5s infinite ease-in-out;
  pointer-events: none;
}

@keyframes barridoOndulado {
  0% {
    /* Iniciamos controlados en Y (0%) para que no invada la parte superior */
    transform: translate(-30%, 0%) rotate(-5deg) scale(0.6) scaleY(0.8);
    opacity: 0;
  }
  15% {
    opacity: 1; /* Ahora el 1 significa mostrar el gradiente fino que creamos, no una plasta */
  }
  85% {
    opacity: 1;
  }
  100% {
    /* Trayectoria diagonal fina hacia abajo (12%) y a la derecha */
    transform: translate(25%, 12%) rotate(-2deg) scale(0.8) scaleY(1.05);
    opacity: 0;
  }
}
</style>